'use strict';
var requireObjectCoercible = require('../internals/require-object-coercible');
var $Object = Object;

/**
 * 获取排除null或undefined的对象
 * @param {any} argument
 * @returns {any}
 */
module.exports = function(argument) {
  return $Object(requireObjectCoercible(argument));
};
